import api from '../api/axios';
import { StoryBaseEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export const getStoryBasesByMember = async (
  memberId: string,
  options?: { page?: number; limit?: number; search?: string },
) => {
  const page = options?.page ?? 1;
  const limit = options?.limit ?? 20;
  const search = options?.search;
  const res = await api.get(withBase(`/story-bases/by-member/${memberId}`), {
    params: {
      page,
      limit,
      ...(search ? { search } : {}),
    },
  });
  return res.data as StoryBaseEntity[];
};

export type StoryBaseCreateRequest = {
  title: string;
  fullStory: string;
  language: string;
  isDialog: boolean;
  target: 'short' | 'youtube' | 'other';
  charactersJson: Array<{ name: string; speaker: string; voiceId: string }>;
  memberId: string;
  description?: string | null;
  estimatedDurationMs?: number | null;
};

export const createStoryBase = async (payload: StoryBaseCreateRequest) => {
  const res = await api.post(withBase(`/story-bases`), payload);
  return res.data as StoryBaseEntity;
};

export const getStoryBase = async (id: string) => {
  const res = await api.get(withBase(`/story-bases/${id}`));
  return res.data as StoryBaseEntity;
};

export type StoryBaseUpdateRequest = {
  title?: string;
  fullStory?: string;
  language?: string;
  isDialog?: boolean;
  target?: 'short' | 'youtube' | 'other';
  charactersJson?: Array<{ name: string; speaker: string; voiceId: string }>;
  description?: string | null;
  estimatedDurationMs?: number | null;
};

export type UpdateStoryBaseResponse = {
  result: StoryBaseEntity;
  message?: string;
  isNewStory?: boolean;
};

export const updateStoryBase = async (id: string, payload: StoryBaseUpdateRequest) => {
  const res = await api.patch(withBase(`/story-bases/${id}`), payload);
  return res.data as UpdateStoryBaseResponse;
};

export const deleteStoryBase = async (id: string) => {
  const res = await api.delete(withBase(`/story-bases/${id}`));
  return res.data as { success?: boolean; message?: string } | null;
};

export type StoryPrepareRequest = {
  fullStory: string;
  isDialog: boolean;
  description?: string | null;
  characters: Array<{ speaker: string; name: string }>;
  language?: string;
};

export type StoryPrepareResponse = {
  fullStory: string;
  estimatedDurationMs?: number;
};

export const prepareStory = async (payload: StoryPrepareRequest) => {
  const res = await api.post(withBase(`/story-bases/structure-dialog`), payload);
  return res.data as StoryPrepareResponse;
};

const storyBaseService = {
  getStoryBasesByMember,
  createStoryBase,
  getStoryBase,
  deleteStoryBase,
  updateStoryBase,
  prepareStory,
};

export default storyBaseService;
